import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vehicleMakeAPI = createApi({
    reducerPath: "vehicleMakeAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllVehicleMakes: builder.mutation({
            query: ({ search}) => {
                let apiUrl = `vehicle/make`;

                if (search) {
                    apiUrl += `?search=${search}`;
                }

                return {
                    url: apiUrl,
                    method: "GET"
                };

            },
            transformResponse: (response) => response,
            providesTags: ["vehicleMake"]
        }),
        createVehicleMake: builder.mutation({
            query: ({body}) => ({
                url: `vehicle/make`,
                method: "POST",
                body
            }),
            invalidatesTags: ["vehicleMake"],
        }),
        updateVehicleMake: builder.mutation({
            query: ({ id, body}) => ({
                url: `vehicle/make/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["vehicleMake"],
        }),
        deleteVehicleMake: builder.mutation({
            query: ({ id }) => ({
                url: `vehicle/make/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["vehicleMake"],
        }),
        bulkUploadVehicleMakes: builder.mutation({
            query: ({body}) => ({
                url: `vehicle/make/batch`,
                method: "POST",
                body
            }),
            invalidatesTags: ["vehicleMake"]
        })
    })
});

export const {
    useGetAllVehicleMakesMutation,
    useCreateVehicleMakeMutation,
    useUpdateVehicleMakeMutation,
    useDeleteVehicleMakeMutation,
    useBulkUploadVehicleMakesMutation,
} = vehicleMakeAPI;

export default vehicleMakeAPI;